// extracted by mini-css-extract-plugin
module.exports = {"gridWrapper":"grid-module--gridWrapper--3Tl6W","cardWrapper":"grid-module--cardWrapper--3nB6x"};